import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Iframe from 'react-iframe';
import {
  Segment,
  Header,
  Grid,
  Button,
  Dropdown,
  Loader,
  Message,
  Checkbox,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import qs from 'qs';
import config from '../../../config';
import { readSpaDocLink, spaLinkForCase } from './spaDocLink';
import { AWSUrl } from '../../utils/url';
import { fetchAPI, fetchM } from '../../actions/fetchM';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { spaFullNumber } from '../../utils/amount';

import * as endpoints from '../../constants/apiEndpoints';

import {
  getLawyerSPACaseStatuses,
  DEVELOPER_CANCELLED,
  DEVELOPER_RECEIVED,
  FIRST_DISBURSEMENT,
  PENDING_APPOINTMENT,
  SPA_SIGNED_PENDING,
  TYPE_CASE_SPA,
  TYPE_CASE_LA,
  getLawyerLACaseStatuses,
  NEW,
  SPA_SIGNED,
  LAWYER_STATUS_ACTIVE,
  LAWYER_STATUS_CANCELLED,
  REP_TYPE_PURCHASER,
  REP_TYPE_DEVELOPER,
} from '../../constants/lawyerCaseStatuses';

import {
  PROPERTY_CATEGORY_LANDED,
} from '../../constants/propertyCategories';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import AppointmentCard from './AppointmentCard';
import LawyerDetail from './LawyerDetail';
import SecondaryLawyerDetail from './SecondaryLawyerDetail';
import PanelLawyersList from '../modals/PanelLawyersList';
import AssignSecondaryLawyer from '../modals/AssignSecondaryLawyer';
import CaseStatusMilestone from './CaseStatusMilestone';
import LawyerAppointment from '../modals/LawyerAppointment';
import SpaCaseDetail from './SpaCaseDetail';
import CaseAssignmentModal from './CaseAssignmentModal';

// lawyerAPI replies 4XX with { error_message } (e.g. "City is required"),
// show that instead of the generic error
const lawyerAPIErrorMessage = (e, fallback) => {
  const res = e && e.response;
  const isValidationStatus = res && res.status >= 400 && res.status < 500
    && ![401, 403].includes(res.status);
  if (isValidationStatus && res.data && res.data.error_message) {
    return res.data.error_message;
  }
  return fallback;
};

// How long one Cloone /sales/create round-trip may take before it is abandoned and reported. A
// stalled request must not serialise every later case's link behind it (Codex round 1 on #3794).
const SPA_LINK_TIMEOUT_MS = 15000;

// Named export for tests; the default export below is the wrapped one the app uses.
export class Cases extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        companyID: PropTypes.int,
      }),
    }),
    token: PropTypes.string,
    data: PropTypes.shape({
      id: PropTypes.string,
      statusID: PropTypes.string,
      project: PropTypes.shape({
        himsDefaultSpaLawyerRepID: PropTypes.string,
      }),
    }).isRequired,
    primaryPurchaser: PropTypes.shape({
      name: PropTypes.string,
    }).isRequired,
    purchasers: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    successBankCase: PropTypes.shape({
      bank: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
    disabled: PropTypes.bool,
    isProjectHimsEnabled: PropTypes.bool,
    bookingID: PropTypes.string,
    loanTrackerProjectID: PropTypes.number,
    setLoading: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      company: PropTypes.object,
      isExternalAgent: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static defaultProps = {
    successBankCase: null,
    disabled: false,
  }
  constructor(props) {
    super(props);
    this.state = {
      cases: {
        SPA: [],
        LA: [],
      },
      nextToken: {
        SPA: null,
        LA: null,
      },
      activeCase: {
        SPA: null,
        LA: null,
      },
      loading: {
        SPA: null,
        LA: null,
      },
      lawyersIDList: [],
      lawyersList: [],
      currentCase: null,
      assignType: 'SPA',
      bookingLawyers: [],
      activeSecondaryLawyer: {},
      showAssignLawyer: false,
      showAssignSecondaryLawyer: false,
      showModalConfirm: false,
      showLawyerAppointment: false,
      doneCount: {
        SPA: 0,
        LA: 0,
      },
      companyDocuments: [],
      assignSameLawyer: false,
      spaDocLink: null,
      spaDocLinkCaseID: null,
    };
  }
  componentDidMount() {
    this.fetchCompanyDocuments();
    if (this.props.bookingID) {
      this.fetchAllLawyerCasesDetails(this.props.bookingID);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { bookingID } = nextProps;
    if (bookingID !== this.props.bookingID) {
      this.fetchAllLawyerCasesDetails(bookingID);
    }
  }
  componentWillUnmount() {
    this.unmounted = true;
    this.abortSpaLink('unmount');
  }
  getMessageList = () => {
    const { data, primaryPurchaser, t } = this.props;
    const list = [];
    const allowLawyerAssignWithoutIC = (data && data.project && data.project.allowLawyerAssignWithoutIC) || false;
    if (!allowLawyerAssignWithoutIC && primaryPurchaser.customer && !(primaryPurchaser.customer.icFrontDocumentID && primaryPurchaser.customer.icFrontDocumentID)) {
      list.push(<Message.Item key="2">{t('Upload purchaser\'s IC')}</Message.Item>);
    }
    if (
      data.project && data.project.propertyCategory && data.project.propertyCategory.category !== PROPERTY_CATEGORY_LANDED && data.projectUnit && !data.projectUnit.streetNumberOrLevel) {
      list.push(<Message.Item key="4">{t('Have a completed unit information (Level is required)')}</Message.Item>);
    }
    return list;
  }
  getOppositeType = assignType => (assignType === TYPE_CASE_SPA ? TYPE_CASE_LA : TYPE_CASE_SPA);
  setLoading = (newLoading = false, type) => new Promise((res) => {
    const { loading } = this.state;
    if (type != null) {
      loading[type] = newLoading;
    } else {
      loading.SPA = newLoading;
      loading.LA = newLoading;
    }
    this.setState({ loading }, () => res(newLoading));
  })
  setExternalLoading = (loading = false) => {
    const { setLoading } = this.props;
    if (setLoading) {
      setLoading(loading);
    }
  }
  setComponentState = (state = {}) => new Promise(res => this.setState(state, () => res(state)))
  setCases = (type, data = [], token, loadMore) => new Promise((res) => {
    const { cases, activeCase, nextToken, lawyersIDList } = this.state;
    const newData = data || [];
    newData.forEach((_data) => {
      const isExist = lawyersIDList.find(id => id === _data.lawyer_id);
      if (!isExist) {
        lawyersIDList.push(_data.lawyer_id);
      }
    });
    const newCases = loadMore ? activeCase[type].concat(newData) : newData;
    let currentCase = newCases.find(d => d.status !== DEVELOPER_CANCELLED);
    if (!activeCase) {
      currentCase = this.state.activeCase[type];
    }
    if (type === TYPE_CASE_SPA && currentCase) {
      // use default type from settings
      currentCase.extra_data = {
        ...currentCase.extra_data,
        repType: this.props.data && this.props.data.project && this.props.data.project.himsDefaultSpaLawyerRepID,
      };
    }
    cases[type] = newCases;
    activeCase[type] = currentCase;
    nextToken[type] = token;
    this.setState({ cases, activeCase, nextToken, lawyersIDList }, () => res(newCases));
  })
  getOppositeLawyerRepType = currentType => (
    currentType === REP_TYPE_DEVELOPER ? REP_TYPE_PURCHASER : REP_TYPE_DEVELOPER
  );
  handleUpdateSecondaryLawyer = (e, validations, data) => {
    e.preventDefault();
    this.updateSecondaryLawyer(data, 'update', validations);
  }
  // One request in flight; a call that arrives meanwhile is COALESCED into one more run after it
  // (not dropped -- the booking or the assignment may have changed underneath) and the request it
  // supersedes is ABORTED, so a stalled answer for the previous case never holds up the next one.
  // A response is applied only if the SPA case it was requested for is still the active one.
  abortSpaLink(reason) {
    if (this.spaLinkAbort) {
      this.spaLinkAbortReason = reason;
      this.spaLinkAbort.abort();
    }
  }
  async fetchSPALink() {
    // fetchAllLawyerCasesDetails reaches here after several awaits, so it can resume after
    // componentWillUnmount with no request yet in flight; nothing must start then.
    if (this.unmounted) return;
    if (this.spaLinkInFlight) {
      this.spaLinkQueued = true;
      this.abortSpaLink('superseded');
      return;
    }
    this.spaLinkInFlight = true;
    try {
      do {
        this.spaLinkQueued = false;
        // eslint-disable-next-line no-await-in-loop
        await this.requestSPALink();
      } while (this.spaLinkQueued && !this.unmounted);
    } finally {
      this.spaLinkInFlight = false;
    }
  }
  async requestSPALink() {
    const Aborter = typeof window !== 'undefined' ? window.AbortController : null;
    const controller = Aborter ? new Aborter() : null;
    this.spaLinkAbort = controller;
    this.spaLinkAbortReason = null;
    const timer = controller
      ? setTimeout(() => this.abortSpaLink('timeout'), SPA_LINK_TIMEOUT_MS)
      : null;
    try {
      // Everything, payload construction included, sits inside the guard: a case without a
      // purchaser is reported once, not thrown past the coalescing loop with queued work lost.
      const { activeCase } = this.state;
      const currentCase = activeCase[TYPE_CASE_SPA];
      const requestedCaseID = currentCase ? currentCase.id : null;
      if (requestedCaseID !== this.spaLinkCaseID) {
        // The link on screen belongs to another case (or to none): clear it on the transition,
        // so case A's download link is never shown for case B when B has no link or fails.
        this.spaLinkCaseID = requestedCaseID;
        if (this.state.spaDocLink && !this.unmounted) {
          this.setState({ spaDocLink: null, spaDocLinkCaseID: null });
        }
      }
      if (!currentCase) return;
      const body = {
        project_mhub_id: currentCase.project_id,
        project_name: currentCase.project_name,
        unit_mhub_id: currentCase.project_unit_id,
        unit_unit_no: currentCase.unit_no,
        purchaser_mhub_id: currentCase.purchaser_id,
        purchaser_nric: currentCase.purchaser.identity_no,
        purchaser_name: currentCase.purchaser.name,
        purchaser_mobile_no: currentCase.purchaser.mobile,
        sales_mhub_id: currentCase.id,
        sales_lawyer_id: currentCase.lawyer_id,
        extra_data: currentCase.extra_data,
      };
      const res = await fetch(`${config.get('clooneURL')}/sales/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
        signal: controller ? controller.signal : undefined,
      });
      // A 500 with an empty body used to throw from res.json() OUTSIDE this try -- an uncaught
      // rejection per page load and nothing in Bugsnag. Now one guarded read, one report.
      const link = await readSpaDocLink(res);
      const latest = this.state.activeCase[TYPE_CASE_SPA];
      const stillCurrent = latest && latest.id === requestedCaseID;
      if (link && stillCurrent && !this.unmounted) {
        this.setState({ spaDocLink: link, spaDocLinkCaseID: requestedCaseID });
      }
    } catch (e) {
      // Only an ABORT is judged by the abort reason. Any other failure -- a case without a
      // purchaser, a bad answer -- is reported even if a supersede happened to land meanwhile.
      const aborted = e && e.name === 'AbortError';
      const reason = aborted ? this.spaLinkAbortReason : null;
      if (reason === 'superseded' || reason === 'unmount') {
        return; // abandoned on purpose; nothing to report
      }
      Bugsnag.notifyException(reason === 'timeout'
        ? new Error(`Cloone sales/create timed out after ${SPA_LINK_TIMEOUT_MS}ms`)
        : e);
    } finally {
      if (timer) clearTimeout(timer);
      if (this.spaLinkAbort === controller) this.spaLinkAbort = null;
    }
  }
  fetchAllLawyerCasesDetails = async (bookingID = null) => {
    const { lawyersIDList } = this.state;
    const promiseArr = [
      this.fetchLawyerCases('SPA', null, bookingID),
      this.fetchLawyerCases('LA', null, bookingID),
    ];
    if (promiseArr.length > 0) {
      await Promise.all(promiseArr);
      const promiseArrLawyer = [];
      lawyersIDList.forEach((id) => {
        promiseArrLawyer.push(this.fetchLawyer(id));
      });
      const promiseResultArray = await Promise.all(promiseArrLawyer);
      this.setState({ lawyersList: promiseResultArray });
      this.fetchSPALink();
      this.fetchSecondaryLawyers();
    }
  }
  async fetchLawyer(lawyerID = null) {
    if (!lawyerID) return null;
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
      return res;
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return null;
    }
  }
  fetchLawyerCases = async (type, nextToken, bookingID = this.props.bookingID) => {
    await this.setLoading(true, type);
    if (!nextToken) {
      const { activeCase } = this.state;
      activeCase[type] = null;
      await this.setComponentState({ activeCase });
    }
    const { t } = this.props;
    const { store } = this.context;
    const query = {
      limit: 10,
      type,
    };
    if (nextToken) {
      query.next_token = nextToken;
    }
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.BOOKING_CASES(bookingID)}/?${qs.stringify(query)}`, null, 'get', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false, type);
      return;
    }

    if (res) {
      await this.setCases(type, res.items, res.next_token, !!nextToken);
    }

    await this.setLoading(false, type);
  }
  async fetchCompanyDocuments(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      page: 1,
    }, q);
    let res;
    try {
      res = await store.dispatch(fetchM(`/company_documents/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const companyDocuments = await res.json();
      await this.setComponentState({
        companyDocuments,
      });
    }
    await this.setLoading(false);
  }
  assignLawyer = async (sub, body) => {
    const { type } = body;
    const { activeCase } = this.state;
    const { store } = this.context;
    const { t } = this.props;
    const { bookingID } = this.props;
    if (activeCase[type]) {
      await store.dispatch(flashErrorMessage({ message: t('Booking can only has 1 active lawyer', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    await this.setExternalLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER_CASES(sub.lawyer_id), body, 'post', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await this.setExternalLoading(false);
      if (e.response && e.response.status === 409) {
        await store.dispatch(flashErrorMessage({ message: t('{{caseType}} is already assigned with a Lawyer', { caseType: body.type, ns: TRANSLATION_FILES.translation }) }));
        return;
      }
      await store.dispatch(flashErrorMessage({ message: lawyerAPIErrorMessage(e, t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation })) }));
      return;
    }
    await this.setComponentState({
      assignSameLawyer: false,
    });
    await this.setExternalLoading(false);

    if (res) {
      this.fetchAllLawyerCasesDetails(bookingID); // fetch newly assigned lawyer details
      activeCase[type] = res;
      await this.setComponentState({ activeCase });
      await store.dispatch(flashSuccessMessage({
        header: t('Assign success', { ns: TRANSLATION_FILES.translation }),
        message: t('Successfully assign case to lawyer {{name}}', { name: sub.lawyer_name, ns: TRANSLATION_FILES.translation }),
      }));
    }
  }
  updateLawyerCase = async (caseData) => {
    await this.setExternalLoading(true);
    const { t, isProjectHimsEnabled } = this.props;
    const { store } = this.context;
    let res;

    if (caseData && caseData.caseStatus === SPA_SIGNED && !caseData.spaDate && isProjectHimsEnabled) {
      await store.dispatch(flashErrorMessage({ message: 'SPA Date is required' }));
      await this.setExternalLoading(false);
      return;
    }

    try {
      res = await store.dispatch(fetchM(`/lawyers/${caseData.lawyerID}/cases/${caseData.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(caseData),
      }));
    } catch (e) {
      await this.setExternalLoading(false);
      // fetchM already handles auth, not-found and session statuses,
      // only surface validation-type errors
      const status = e.res ? e.res.status : 0;
      if (status >= 400 && status < 500 && ![401, 403, 404, 428].includes(status)) {
        let message = '';
        try {
          message = await e.res.text();
        } catch (readErr) {
          message = '';
        }
        if (message) {
          await store.dispatch(flashErrorMessage({ message }));
          return;
        }
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }

    if (res) {
      const data = await res.json();
      const { activeCase } = this.state;
      if (caseData.type === TYPE_CASE_SPA) {
        data.extra_data = {
          ...data.extra_data,
          repType: caseData.repType || activeCase[caseData.type].extra_data.repType,
        };
      }
      activeCase[caseData.type] = caseData.caseStatus === DEVELOPER_CANCELLED ? null : Object.assign({}, data, {
        lawyer: activeCase[caseData.type] && activeCase[caseData.type].lawyer ? activeCase[caseData.type].lawyer : null,
      });
      await this.setComponentState({ activeCase, selectedStatus: null, currentCase: null });
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Status successfully updated', { ns: TRANSLATION_FILES.translation }),
      }));
    }

    await this.setExternalLoading(false);

    if (!this.state.activeCase[caseData.type]) {
      this.fetchLawyerCases(caseData.type);
    }
  }
  updateCaseAppointment = async (body) => {
    await this.setLoading(true, TYPE_CASE_SPA);
    await this.setExternalLoading(true);
    const { activeCase } = this.state;
    const { t } = this.props;
    const currentCase = activeCase.SPA;
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER_CASE_DETAILS(currentCase.lawyer_id, currentCase.id), body, 'put', {
        'X-Api-Token': process.env.LAWYER_API_TOKEN,
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: lawyerAPIErrorMessage(e, t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation })) }));
      await this.setLoading(false, TYPE_CASE_SPA);
      await this.setExternalLoading(false);
      return;
    }

    if (res) {
      activeCase.SPA = res;
      await this.setComponentState({ activeCase, showLawyerAppointment: false });
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Appointment successfully updated', { ns: TRANSLATION_FILES.translation }),
      }));
    }
    await this.setLoading(false, TYPE_CASE_SPA);
    await this.setExternalLoading(false);
  }

  generateDocumentKey = (key = null) => {
    if (key) {
      if (key.includes('.jpg')) {
        return AWSUrl(this.props.appConfig, `${key}`);
      }
      return AWSUrl(this.props.appConfig, `${key}100.jpg`);
    }
    return 'none';
  }

  generateBookingData = (caseType = TYPE_CASE_SPA) => {
    const { data, primaryPurchaser, purchasers, successBankCase } = this.props;
    const { companyDocuments } = this.state;
    const casePurchasers = [];
    const property = {
      project_code: data.projectID,
      project_name: data.project.name,
      project_short_name: data.project.shortName,
      project_type: data.project.propertyCategory.category,
      block: data.projectUnit.zoneOrBlock,
      level: data.projectUnit.streetNumberOrLevel,
      unit: data.projectUnit,
      unit_no: data.projectUnit.reference,
      unit_type: data.projectUnit.projectUnitLayout.name,
      size: `${data.projectUnit.size} ${data.project.sizeSuffix === 'square_feet' ? 'sqft' : 'sqm'}`,
      selling_price: parseFloat(spaFullNumber(data.projectUnit)),
      phone_prefix: data.project.phonePrefix,
      phone: data.project.phone,
      address1: data.project.address1,
      address2: data.project.address2,
      address3: data.project.address3,
      address4: data.project.address4,
      postcode: data.project.address5,
      city: data.project.address6,
      state: data.project.address7,
      country: data.project.country,
      project_pictures: [],
    };
    if (data.project.projectPictures && process.env.AWS_BUCKET && process.env.AWS_REGION) {
      data.project.projectPictures.forEach((pp) => {
        property.project_pictures.push({
          id: pp.pictureID,
          picture: `https://s3-${process.env.AWS_REGION}.amazonaws.com/${process.env.AWS_BUCKET}/${pp.picture.key}070.jpg`,
          isCover: pp.isCover,
          type: pp.type,
        });
      });
    }
    const booking = {
      payment_amount: data.paymentAmount,
      financial_type: data.paymentMethodID,
      bank_name: successBankCase ? successBankCase.bank.name : '',
      banker_name: successBankCase ? successBankCase.banker.name : '',
      banker_mobile: successBankCase && successBankCase.banker && successBankCase.banker.mobile ? `+${successBankCase.banker.mobilePrefix === 'other' ? '' : successBankCase.banker.mobilePrefix}${successBankCase.banker.mobile}` : '',
      selling_price: parseFloat(spaFullNumber(data)),
      loan_amount: successBankCase && successBankCase.loanAmount > 0 ? parseInt(successBankCase.loanAmount, 10) : 0,
    };

    if (purchasers.length > 0) {
      purchasers.forEach((p) => {
        let mobile;
        if (p.mobile) {
          mobile = `+${p.mobilePrefix === 'other' ? '' : p.mobilePrefix}${p.mobile}`;
        }
        let phone;
        if (p.phone) {
          phone = `+${p.phonePrefix === 'other' ? '' : p.phonePrefix}${p.phone}`;
        }
        let identityType = 'ic_number';
        switch (p.customer && p.customer.identityTypeID) {
          case 2:
            identityType = 'passport';
            break;
          case 3:
            identityType = 'military_police';
            break;
          case 4:
            identityType = 'company_reg_number';
            break;
          case 5:
            identityType = 'id_number';
            break;
          default:
            identityType = 'ic_number';
            break;
        }
        const nricFront = this.generateDocumentKey(p.customer && p.customer.icFrontDocument && p.customer.icFrontDocument.key);
        const nricBack = this.generateDocumentKey(p.customer && p.customer.icBackDocument && p.customer.icBackDocument.key);

        const purchaser = {
          id: p.customerID,
          address_1: p.address1,
          address_2: p.address2,
          postcode: p.address5,
          city: p.address6,
          state: p.address7,
          country: p.country,
          email: p.email,
          gender: p.gender,
          identity_no: p.customer && p.customer.identity,
          identity_type: identityType,
          marital_status: p.maritalStatus,
          mobile,
          name: p.name,
          nationality: p.nationality,
          nric_back: nricBack,
          nric_front: nricFront,
          occupation: p.jobTitle,
          phone,
          race: p.race,
        };
        casePurchasers.push(purchaser);
      });
    }

    let mobile;
    if (primaryPurchaser.mobile) {
      mobile = `+${primaryPurchaser.mobilePrefix === 'other' ? '' : primaryPurchaser.mobilePrefix}${primaryPurchaser.mobile}`;
    }
    let phone;
    if (primaryPurchaser.phone) {
      phone = `+${primaryPurchaser.phonePrefix === 'other' ? '' : primaryPurchaser.phonePrefix}${primaryPurchaser.phone}`;
    }
    let identityType = 'ic_number';
    switch (primaryPurchaser.customer && primaryPurchaser.customer.identityTypeID) {
      case 2:
        identityType = 'passport';
        break;
      case 3:
        identityType = 'military_police';
        break;
      case 4:
        identityType = 'company_reg_number';
        break;
      case 5:
        identityType = 'id_number';
        break;
      default:
        identityType = 'ic_number';
        break;
    }
    const nricFront = this.generateDocumentKey(primaryPurchaser.customer && primaryPurchaser.customer.icFrontDocument && primaryPurchaser.customer.icFrontDocument.key);
    const nricBack = this.generateDocumentKey(primaryPurchaser.customer && primaryPurchaser.customer.icBackDocument && primaryPurchaser.customer.icBackDocument.key);

    const purchaser = {
      id: primaryPurchaser.customerID,
      address_1: primaryPurchaser.address1,
      address_2: primaryPurchaser.address2,
      postcode: primaryPurchaser.address5,
      city: primaryPurchaser.address6,
      state: primaryPurchaser.address7,
      country: primaryPurchaser.country,
      email: primaryPurchaser.email,
      gender: primaryPurchaser.gender,
      identity_no: primaryPurchaser.customer && primaryPurchaser.customer.identity,
      identity_type: identityType,
      marital_status: primaryPurchaser.maritalStatus,
      mobile,
      name: primaryPurchaser.name,
      nationality: primaryPurchaser.nationality,
      nric_back: nricBack,
      nric_front: nricFront,
      occupation: primaryPurchaser.jobTitle,
      phone,
      race: primaryPurchaser.race,
    };


    const documents = {
      nric_front: nricFront,
      nric_back: nricBack,
    };
    if (companyDocuments.length > 0) {
      companyDocuments.forEach((file) => {
        let key = file.id;
        switch (key) {
          case 'm_a':
            key = 'memorandum';
            break;
          case 'resolution':
            key = 'company_resolution';
            break;
          default:
            key = file.id;
        }
        documents[key] = AWSUrl(this.props.appConfig, file.key);
      });
    }
    const caseData = {
      type: caseType,
      company_id: this.props.appConfig && this.props.appConfig.data ? this.props.appConfig.data.companyID : 0,
      project_id: this.props.loanTrackerProjectID,
      project_unit_id: data.projectUnit.id,
      booking_id: this.props.bookingID,
      purchaser_id: primaryPurchaser.customerID,
      property,
      booking,
      purchasers: casePurchasers,
      purchaser,
      documents,
    };
    return caseData;
  }
  handleLoadMore = (type) => {
    const { bookingID } = this.props;
    const { nextToken } = this.state;
    if (bookingID) {
      this.fetchLawyerCases(type, nextToken);
    }
  }
  async fetchSecondaryLawyers() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const { activeCase } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/lawyers/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const bookingLawyers = await res.json();
      const activeSecondaryLawyer = bookingLawyers && bookingLawyers.find(bl => bl.status === LAWYER_STATUS_ACTIVE);

      if (activeSecondaryLawyer && activeCase[TYPE_CASE_SPA]) {
        activeCase[TYPE_CASE_SPA].extra_data = {
          ...activeCase[TYPE_CASE_SPA].extra_data,
          repType: this.getOppositeLawyerRepType(activeSecondaryLawyer.repType),
        };
      }
      await this.setComponentState({
        bookingLawyers,
        activeSecondaryLawyer,
        activeCase,
      });
    }
    await this.setLoading(false);
  }
  handleShowAssignSecondaryLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAssignSecondaryLawyer: true,
      assignType: TYPE_CASE_SPA,
    });
  }
  handleCloseAssignSecondaryLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAssignSecondaryLawyer: false,
    });
  }
  handleCreateSecondaryLawyer = async (e, validations, newLawyer) => {
    const { store } = this.context;
    const { t } = this.props;
    if (e) { e.preventDefault(); }
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    this.setState({
      showAssignSecondaryLawyer: false,
    });
    await this.setLoading(true, TYPE_CASE_SPA);
    await this.setExternalLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/lawyers/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(newLawyer),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false, TYPE_CASE_SPA);
    await this.setExternalLoading(false);
    const activeSecondaryLawyer = await res.json();
    await this.setComponentState({ activeSecondaryLawyer });
    await store.dispatch(flashSuccessMessage({
      header: t('Assign 2nd Lawyer Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('Lawyer {{name}} is successfully added', { name: activeSecondaryLawyer.name, ns: TRANSLATION_FILES.translation })}.`,
    }));
  }
  handleEditSecondaryLawyer = () => {
    const { activeSecondaryLawyer } = this.state;
    this.setState({
      showAssignSecondaryLawyer: true,
      editingSecondaryLawyer: activeSecondaryLawyer,
    });
  }
  handleRemoveSecondaryLawyer = () => {
    const { activeSecondaryLawyer } = this.state;
    const req = activeSecondaryLawyer;
    req.status = LAWYER_STATUS_CANCELLED;
    this.updateSecondaryLawyer(req, 'remove');
  }
  handleUpdateRepType = (type) => {
    const { activeSecondaryLawyer } = this.state;
    // update active booking lawyer's reptype
    if (activeSecondaryLawyer && activeSecondaryLawyer.repType === type) {
      const req = activeSecondaryLawyer;
      req.repType = this.getOppositeLawyerRepType(type);
      this.updateSecondaryLawyer(req, 'updateRepType');
    }
  }
  updateSecondaryLawyer = async (lawyerData, type = 'update', validations = []) => {
    const { store } = this.context;
    const { data, t } = this.props;
    const { activeCase } = this.state;
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    this.setState({
      showAssignSecondaryLawyer: false,
    });
    await this.setLoading(true, TYPE_CASE_SPA);
    await this.setExternalLoading(true);
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${this.props.bookingID}/lawyers/${lawyerData.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(lawyerData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setLoading(false, TYPE_CASE_SPA);
    await this.setExternalLoading(false);
    let activeSecondaryLawyer = await res.json();
    if ((type === 'updateRepType' || type === 'update') && activeCase[TYPE_CASE_SPA]) {
      activeCase[TYPE_CASE_SPA].extra_data = {
        ...activeCase[TYPE_CASE_SPA].extra_data,
        repType: this.getOppositeLawyerRepType(activeSecondaryLawyer.repType),
      };
      await this.setComponentState({ activeCase });
    }
    let message = 'Updated';
    if (type === 'remove') {
      message = 'Delete Success';
      activeSecondaryLawyer = {};
    }
    await this.setComponentState({ activeSecondaryLawyer });
    await store.dispatch(flashSuccessMessage({
      header: t(message, { ns: TRANSLATION_FILES.translation }),
      // message: `${t('Lawyer {{name}} is successfully deleted', { name: newLawyer.name, ns: TRANSLATION_FILES.translation })}.`,
    }));

    if (type === 'remove') {
      if (activeCase[TYPE_CASE_SPA] && data && data.project) {
        // set to default value from settings if there's no active 2nd lawyer
        activeCase[TYPE_CASE_SPA].extra_data = {
          ...activeCase[TYPE_CASE_SPA].extra_data,
          repType: data.project.himsDefaultSpaLawyerRepID,
        };
        await this.setComponentState({ activeCase });
      }
      this.fetchSecondaryLawyers();
    }
  }
  handleShowAssignLawyer = (e, assignType) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAssignLawyer: true,
      assignType,
    });
  }
  handleCloseAssignLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showAssignLawyer: false,
    });
  }
  handleAssignLawyer = (e, selected) => {
    if (e) { e.preventDefault(); }
    this.setState({ showAssignLawyer: false }, () => {
      const { assignType, assignSameLawyer } = this.state;
      const caseData = this.generateBookingData(assignType);
      this.assignLawyer(selected, caseData);
      if (assignSameLawyer) {
        const otherCaseData = this.generateBookingData(this.getOppositeType(assignType));
        this.assignLawyer(selected, otherCaseData);
      }
    });
  }
  handleShowModalConfirm = (e, value, currentCase) => {
    if (e) { e.preventDefault(); }
    this.setState({
      currentCase,
      showModalConfirm: true,
      selectedStatus: value,
    });
  }
  handleCloseModalConfirm = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showModalConfirm: false,
      selectedStatus: null,
    });
  }
  handleShowLawyerAppointment = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showLawyerAppointment: true,
    });
  }
  handleCloseLawyerAppointment = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showLawyerAppointment: false,
    });
  }
  handleUpdateLawyerAppointment = (e, appointment) => {
    if (e) { e.preventDefault(); }
    if (!this.canUpdateAppointment()) {
      const { store } = this.context;
      const { t } = this.props;
      store.dispatch(flashErrorMessage({ message: t('Appointment cannot be updated', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }

    this.updateCaseAppointment(appointment);
  }
  handleUpdateSpaCaseDetails = (e, d) => {
    if (d) {
      const { bookingID } = this.props;
      const { activeCase } = this.state;
      const caseData = {
        id: activeCase[TYPE_CASE_SPA].id,
        lawyerID: activeCase[TYPE_CASE_SPA].lawyer_id,
        bookingID,
        caseStatus: activeCase[TYPE_CASE_SPA].status,
        previousSpaDate: d.spa_date ? moment(d.previous_spa_date).toDate() : null,
        spaDate: d.spa_date ? moment(d.spa_date).toDate() : null,
        spaStampedDate: d.spa_stamped_date ? moment(d.spa_stamped_date).toDate() : null,
        spaSolicitorRefNo: d.spa_solicitor_ref_no,
        type: TYPE_CASE_SPA,
        bypassUpdateCheck: true,
      };
      if (d.repType) {
        caseData.repType = d.repType;
      }
      this.updateLawyerCase(caseData);
      // update active booking lawyer's reptype
      this.handleUpdateRepType(d.repType);
    }
  }
  handleUpdateLawyerCase = (e, previousStatus, caseUpdate) => {
    if (e) { e.preventDefault(); }
    const { bookingID } = this.props;
    const { selectedStatus } = this.state;

    this.setState({ showModalConfirm: false }, () => {
      const caseData = {
        id: caseUpdate.id,
        lawyerID: caseUpdate.lawyer_id,
        bookingID,
        caseStatus: selectedStatus,
        previousCaseStatus: previousStatus || (caseUpdate.type === TYPE_CASE_SPA ? PENDING_APPOINTMENT : NEW),
        spaDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.spa_date ? moment(caseUpdate.extra_data.spa_date).toDate() : null,
        previousSpaDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.previous_spa_date ? moment(caseUpdate.extra_data.previous_spa_date).toDate() : null,
        spaStampedDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.spa_stamped_date ? moment(caseUpdate.extra_data.spa_stamped_date).toDate() : null,
        spaSolicitorRefNo: caseUpdate && caseUpdate.extra_data ? caseUpdate.extra_data.spa_solicitor_ref_no : '',
        type: caseUpdate.type,
      };
      this.updateLawyerCase(caseData);
    });
  }
  checkDisableLawyer = (sub) => {
    const { cases, assignType } = this.state;
    return cases[assignType].some(c => c.lawyer_id === sub.lawyer_id);
  }
  canUpdateAppointment = () => {
    const { activeCase } = this.state;
    if (activeCase && activeCase.SPA) {
      const { status } = activeCase.SPA;
      return status === PENDING_APPOINTMENT ||
        status === SPA_SIGNED_PENDING;
    }
    return false;
  }
  handleCount = (lawyer, type) => {
    const { activeCase, doneCount } = this.state;
    if (activeCase[type]) {
      if (lawyer.id === activeCase[type].lawyer_id) {
        activeCase[type].lawyer = lawyer;
      }
    }
    doneCount[type] += 1;
    this.setState({
      activeCase,
      doneCount,
    });
  }
  hasAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isSuperAdmin;
  }
  handleCheckChange = (e, { checked }) => {
    this.setState({
      assignSameLawyer: checked,
    });
  }
  hasUpdateLASPAAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isAdminBasic || auth.isBranchLeader;
  }

  isLawyerUpdateDisabled = (status, type) => {
    const { loading } = this.state;
    return loading[type] || this.props.disabled || (
      status === DEVELOPER_RECEIVED || status === FIRST_DISBURSEMENT
    );
  }

  isLawyerAssignDisabled = type => this.state.loading[type] || this.props.disabled || this.props.data.statusID === 'cancelled_developer' || this.props.data.statusID === 'expired' || this.props.auth.isExternalAgent

  renderAppointment = (appointment) => {
    const { loading } = this.state;
    const { t } = this.props;
    if (appointment) {
      const { date_time: dateTime } = appointment;
      return (
        <Grid columns={3} doubling>
          {
            dateTime ? (
              <Grid.Column>
                <AppointmentCard timestamp={dateTime} />
              </Grid.Column>
            ) : Array(3).fill(3).map((d, idx) => (
              <Grid.Column key={idx}>
                <AppointmentCard timestamp={appointment[`slot_${idx + 1}`]} />
              </Grid.Column>
            ))
          }
        </Grid>
      );
    }
    return (
      <Segment basic padded>
        <Button
          primary
          onClick={this.handleShowLawyerAppointment}
          disabled={loading.SPA || this.props.disabled}
        >
          {t('Schedule')}
        </Button>
      </Segment>
    );
  }
  renderCurrentSecondarySpaLawyer = (type) => {
    const { activeSecondaryLawyer, activeCase } = this.state;
    if (activeSecondaryLawyer && activeSecondaryLawyer.id) {
      return (
        <SecondaryLawyerDetail
          data={activeSecondaryLawyer}
          lawyerID={activeSecondaryLawyer.id}
          onDelete={this.handleRemoveSecondaryLawyer}
          onEdit={this.handleEditSecondaryLawyer}
        />
      );
    }
    return activeCase[type] && (
      <Grid.Column width={16} textAlign="center">
        <Button
          primary
          onClick={this.handleShowAssignSecondaryLawyer}
          icon="add user"
          labelPosition="left"
          content={
            <div>
              Assign 2nd lawyer
              <br />
              <small>For HIMS e-SPA</small>
            </div>
          }
        />
      </Grid.Column>
    );
  }
  renderCurrentCase = (type) => {
    const { activeCase, activeSecondaryLawyer, lawyersList } = this.state;
    const { t, auth, isProjectHimsEnabled } = this.props;
    const company = auth && auth.company ? auth.company : null;
    const currentCase = activeCase[type];
    if (currentCase) {
      const { appointment, status, created_at: createdAt, status_updated_at: statusUpdatedAt } = currentCase;
      const canUpdateAppointment = appointment && this.canUpdateAppointment();
      return (
        <Grid stackable>
          <Grid.Row>
            <Grid.Column width={16} textAlign="left">
              <CaseStatusMilestone
                type={type}
                status={status}
                createdAt={createdAt}
                statusUpdatedAt={statusUpdatedAt}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column mobile={16} tablet={8} computer={8}>
              <Grid verticalAlign="middle">
                <Grid.Column textAlign="left" width={4}>
                  <Header>{t('Status')}:</Header>
                </Grid.Column>
                <Grid.Column textAlign="right" width={12}>
                  <Dropdown
                    fluid
                    disabled={this.isLawyerUpdateDisabled(status, type)}
                    name="status"
                    onChange={(e, { value }) => this.handleShowModalConfirm(e, value, currentCase)}
                    options={(type === TYPE_CASE_SPA ? getLawyerSPACaseStatuses(status, company, this.hasUpdateLASPAAccess()) : getLawyerLACaseStatuses(status, company, this.hasUpdateLASPAAccess())).map(opt => ({
                      ...opt,
                      text: t(opt.text, { ns: TRANSLATION_FILES.constants }),
                    }))}
                    placeholder={t('Select {{title}}', { title: t('Status') })}
                    selection
                    selectOnBlur={false}
                    value={status}
                  />
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          {
            type === TYPE_CASE_LA ? (
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <LawyerDetail
                    data={lawyersList.find(lawyer => lawyer.id === currentCase.lawyer_id)}
                    basic
                    lawyerID={currentCase.lawyer_id}
                    canFetch
                    onDone={lawyer => this.handleCount(lawyer, type)}
                  />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Segment className="RemarksCard">
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={16}>
                        <Header>{t('Remarks')}</Header>
                      </Grid.Column>
                      <Grid.Column textAlign="left" width={16}>
                        {this.renderRemarksComponent(currentCase)}
                      </Grid.Column>
                    </Grid>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
          {
            type === TYPE_CASE_SPA ? (
              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <SpaCaseDetail
                    basic
                    data={currentCase && currentCase.extra_data ? currentCase.extra_data : null}
                    loading={this.state.loading.SPA}
                    onUpdate={this.handleUpdateSpaCaseDetails}
                    isProjectHimsEnabled={isProjectHimsEnabled}
                    hasActiveSecondaryLawyer={activeSecondaryLawyer && activeSecondaryLawyer.id}
                  />
                  <LawyerDetail
                    data={lawyersList.find(lawyer => lawyer.id === currentCase.lawyer_id)}
                    basic
                    lawyerID={currentCase.lawyer_id}
                    canFetch
                    onDone={lawyer => this.handleCount(lawyer, type)}
                  />
                  <Segment basic className="LawyerCaseAppointment">
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={canUpdateAppointment ? 12 : 16}>
                        <Header>{t('Appointments')}</Header>
                      </Grid.Column>
                      {
                        canUpdateAppointment ? (
                          <Grid.Column textAlign="right" width={4}>
                            <Button
                              primary
                              onClick={this.handleShowLawyerAppointment}
                              icon="edit"
                            />
                          </Grid.Column>
                        ) : null
                      }
                      <Grid.Column width={16} textAlign={appointment ? 'left' : 'center'}>
                        {this.renderAppointment(appointment)}
                      </Grid.Column>
                    </Grid>
                  </Segment>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <Segment className="RemarksCard">
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={16}>
                        <Header>{t('Remarks')}</Header>
                      </Grid.Column>
                      <Grid.Column textAlign="left" width={16}>
                        {this.renderRemarksComponent(currentCase)}
                      </Grid.Column>
                    </Grid>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
        </Grid>
      );
    }
    return (
      <Button
        primary
        onClick={e => this.handleShowAssignLawyer(e, type)}
        icon="add user"
        content={t('Assign lawyer')}
        disabled={this.isLawyerAssignDisabled(type)}
      />
    );
  }
  renderRemarksComponent = (c) => {
    const { lawyersList } = this.state;
    const lawyerInfo = lawyersList.find(lawyer => lawyer.id === c.lawyer_id);
    const q = {
      caseid: c.id,
      mailsubject: `${c.type} Case`,
      senderorg: this.props.auth.company.shortName,
      projname: c.property.project_name,
      unitno: c.property.unit_no,
    };
    if (lawyerInfo) {
      q.recname = lawyerInfo.name;
      q.recmail = lawyerInfo.email;
      const query = Object.assign({}, q);
      const remarksURL = `${config.get('remarksURL')}/?${qs.stringify(query)}`;
      return (
        <div className="RemarksContainer">
          <Iframe className="Remarks" url={remarksURL} />
        </div>
      );
    }
    return (
      <Segment basic padded>
        <Loader active inline="centered" />
      </Segment>
    );
  }
  renderCasesByType = (type) => {
    const {
      bookingLawyers, nextToken, cases, activeCase, doneCount, lawyersList, spaDocLink, spaDocLinkCaseID,
    } = this.state;
    // Only a link fetched FOR the active SPA case is ever shown (see spaLinkForCase).
    const spaLinkToShow = spaLinkForCase(activeCase.SPA, spaDocLink, spaDocLinkCaseID);
    const { isProjectHimsEnabled, t } = this.props;
    const currentCase = activeCase[type];
    return (
      <Grid.Column width={16} className={`section ${type}`}>
        <Grid columns={3}>
          <Grid.Row>
            <Grid.Column tablet={4} computer={3} />
            <Grid.Column mobile={16} tablet={8} computer={10}>
              <Header>{t('{{caseType}} Tracker', { caseType: type, ns: TRANSLATION_FILES.screens })}</Header>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={4} computer={3}>
              {
                currentCase === activeCase.SPA && spaLinkToShow && (
                  <Button
                    className="DownloadSPA"
                    onClick={() => window.open(spaLinkToShow, '_blank')}
                    content={t('Download SPA')}
                    size="small"
                  />
                )
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid columns={2} stackable>
          <Grid.Column width={16}>
            {this.renderCurrentCase(type)}
          </Grid.Column>
          {
            cases[type].filter(d => d.status === DEVELOPER_CANCELLED).map((item, idx) => (
              <Grid.Column key={item.id || idx}>
                <LawyerDetail
                  cancelled
                  data={lawyersList.find(lawyer => lawyer.id === item.lawyer_id)}
                  lawyerID={item.lawyer_id}
                  canFetch={(idx === 0 && !activeCase[type]) || (doneCount[type] === idx + 1)}
                  onDone={lawyer => this.handleCount(lawyer, type)}
                />
              </Grid.Column>
              ))
          }
          {
            (nextToken[type] && cases[type].length > 0) ? (
              <Grid.Column width={16} textAlign="center">
                <Button
                  color="teal"
                  onClick={() => this.handleLoadMore(type)}
                  content={t('Load more')}
                />
              </Grid.Column>
            ) : null
          }
          <Grid.Column width={16}>
            {isProjectHimsEnabled && type === TYPE_CASE_SPA && this.renderCurrentSecondarySpaLawyer(type)}
          </Grid.Column>
          {
            isProjectHimsEnabled && type === TYPE_CASE_SPA && bookingLawyers &&
            bookingLawyers.filter(d => d.status === LAWYER_STATUS_CANCELLED).map((item, idx) => (
              <Grid.Column key={item.id || idx}>
                <SecondaryLawyerDetail
                  cancelled
                  data={item}
                  lawyerID={item.id}
                />
              </Grid.Column>
            ))
          }
        </Grid>
      </Grid.Column>
    );
  }
  renderContent = (list) => {
    const { loading } = this.state;
    const { t } = this.props;
    if (loading.SPA && loading.LA) {
      return <Loader inline="centered" active>{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>;
    }
    if (list.length > 0) {
      return (
        <Message
          warning
        >
          <Message.Header>{t('To assign lawyer, you need to')}:</Message.Header>
          <Message.List>
            {list}
          </Message.List>
        </Message>
      );
    }
    return (
      <Grid stackable stretched>
        {this.renderCasesByType(TYPE_CASE_SPA)}
        {this.renderCasesByType(TYPE_CASE_LA)}
      </Grid>
    );
  }
  renderExtra = (selected) => {
    const { assignType, activeCase, cases } = this.state;
    const { t } = this.props;
    if (selected) {
      const oppositeType = assignType === TYPE_CASE_SPA ? TYPE_CASE_LA : TYPE_CASE_SPA;
      const isCancelled = cases && cases[oppositeType] && cases[oppositeType].some(s => s.lawyer_id === selected.lawyer_id);
      if (activeCase && !activeCase[oppositeType] && !isCancelled) {
        return (
          <Checkbox
            label={t('This lawyer is also my {{caseType}} Lawyer', { caseType: oppositeType, ns: TRANSLATION_FILES.screens })}
            onChange={this.handleCheckChange}
          />
        );
      }
    }
    return null;
  }
  render() {
    const { data, t, isProjectHimsEnabled } = this.props;
    const { loading, selectedStatus, activeCase, currentCase, assignType } = this.state;
    const messageList = this.getMessageList();

    return (
      <Grid stackable stretched className="LawyerCases">
        <PanelLawyersList
          company={this.props.auth.company}
          open={this.state.showAssignLawyer}
          onClose={this.handleCloseAssignLawyer}
          onConfirm={this.handleAssignLawyer}
          selected={this.state.cases[assignType]}
          loanTrackerProjectID={this.props.loanTrackerProjectID}
          projectName={data ? data.name : ''}
          loading={loading.SPA || loading.LA}
          setLoading={this.setLoading}
          extraNode={this.renderExtra}
        />
        <AssignSecondaryLawyer
          onClose={this.handleCloseAssignSecondaryLawyer}
          onCreate={this.handleCreateSecondaryLawyer}
          onUpdate={this.handleUpdateSecondaryLawyer}
          open={this.state.showAssignSecondaryLawyer}
          repType={this.getOppositeLawyerRepType(data.project.himsDefaultSpaLawyerRepID)}
          data={this.state.editingSecondaryLawyer}
        />
        <LawyerAppointment
          appointment={activeCase.SPA ? activeCase.SPA.appointment : null}
          open={this.state.showLawyerAppointment}
          onClose={this.handleCloseLawyerAppointment}
          onConfirm={this.handleUpdateLawyerAppointment}
          loading={loading.SPA}
        />
        <CaseAssignmentModal
          data={currentCase}
          loading={currentCase && currentCase.type ? loading[currentCase.type] : false}
          onClose={this.handleCloseModalConfirm}
          onUpdate={this.handleUpdateLawyerCase}
          open={this.state.showModalConfirm}
          selectedStatus={selectedStatus}
          isProjectHimsEnabled={isProjectHimsEnabled}
        />
        <Grid.Column width={16}>
          <Header className="new_title" as="h5" attached="top">
            {t('Lawyer').toUpperCase()}
          </Header>
          <Segment attached secondary={messageList.length > 0}>
            {this.renderContent(messageList)}
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(connect(Cases.mapStateToProps)(Cases));



// WEBPACK FOOTER //
// ./src/containers/Lawyer/Cases.jsx